import publicLoansApiClient from '@app/clients/public-loans-api-client';
import createBaseQuery from './createBaseQuery';
const publicLoansApiBaseQuery = createBaseQuery(publicLoansApiClient);
export default publicLoansApiBaseQuery;
